// src\themes\default\components\animations\textReveal.ts

// روی والد (گروه متن) قرار می‌گیره تا فرزندهاش رو با تاخیر پشت سر هم انیمیت کنه
export const textGroupVariants = {
    hidden: {},
    visible: {
        transition: {
            staggerChildren: 0.35,
            delayChildren: 0.15,
        },
    },
};

// روی هر آیتم متنی (تیتر، پاراگراف، دکمه) قرار می‌گیره
export const textItemVariants = {
    hidden: {
        opacity: 0,
        y: 34,
        filter: 'blur(10px)',
    },
    visible: {
        opacity: 1,
        y: 0,
        filter: 'blur(0px)',
        transition: {
            duration: 1.3,
            ease: [0.22, 1, 0.36, 1] as const,
        },
    },
};